import TextEditorCustomize from '@/components/TextEditorCustomize'
import CancelIcons from '@/icons/CancelIcons'
import ClockIcons from '@/icons/ClockIcons'
import LocationIcons from '@/icons/LocationIcons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ErrorBoundary, Typogaphy } from 'vnetwork-ui'
import { EventFormData } from '../types'
import Departments from './Departments'
import Employees from './Employees'

interface ParticipantDisplayProps extends Partial<EventFormData> {}

const ParticipantDisplay: React.FC<ParticipantDisplayProps> = ({
    participant_scope,
    title,
    start_date,
    description,
    departments,
    employees,
    start_time,
    location,
    room_enabled,
    room_name,
}) => {
    const { t } = useTranslation()

    const renderParticipants = () => {
        switch (participant_scope) {
            case 'all':
                return (
                    <div className="flex items-center gap-2">
                        <Button
                            size="small"
                            className="bg-secondary-20 text-primary font-normal"
                        >
                            {t('events.participants.all')}
                        </Button>
                    </div>
                )

            case 'department':
                return <Departments departments={departments} />

            case 'team':
                return <Employees employees={employees} />

            default:
                return null
        }
    }

    return (
        <div className="p-4 mt-4">
            <Typogaphy className="text-lg font-semibold text-gray-900 mb-4 text-center">
                {t('dashboard.events.create_event_success_title')}
            </Typogaphy>
            <Typogaphy
                size="small"
                className="font-medium text-center text-[20px]"
            >
                {title}
            </Typogaphy>
            <div className="flex gap-3 items-center justify-center mb-2">
                <div className="flex gap-1">
                    <ClockIcons className="w-4 h-4 text-primary" />
                    <ErrorBoundary>
                        <Typogaphy size="small">{start_time}</Typogaphy>
                    </ErrorBoundary>
                </div>
                <div className="flex gap-1">
                    <CancelIcons className="w-4 h-4 text-primary" />
                    <Typogaphy size="small">{start_date}</Typogaphy>
                </div>
                <div className="flex gap-1">
                    <LocationIcons className="w-2.5 h-4 text-primary" />
                    <Typogaphy size="small">
                        {room_enabled
                            ? t(`events.rooms.${room_name}`)
                            : location}
                    </Typogaphy>
                </div>
            </div>
            <div className="rounded-lg border border-gray-200 p-2">
                <TextEditorCustomize
                    value={{
                        text:
                            description || t('dashboard.events.no_description'),
                        attachments: [],
                    }}
                    readOnly
                    maxLine={3}
                />
            </div>
            <div className="flex items-center justify-center mt-4 mb-2">
                <Typogaphy size="small" className="text-gray-500">
                    {t('dashboard.events.create_event_success_description')}
                </Typogaphy>
            </div>
            {renderParticipants()}
        </div>
    )
}

export default ParticipantDisplay
